"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paywall = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
/**
 * A paywall that appears on hover and prompts the user to upgrade.
 * Currently designed & implemented specifically for use around a
 * Frame body, though it should work in other places as well.
 *
 * The paywall uses absolute positioning to occlude the desired
 * content, so there must be a relatively positioned parent to
 * scope the paywall to a that portion of the UI.
 */
function Paywall({ sx }) {
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: Object.assign({ pointerEvents: "auto", cursor: "not-allowed", position: "absolute", top: 0, bottom: 0, left: 0, right: 0, transition: "background-color 0.2s", "&:hover": {
                bgcolor: "rgba(0 0 0 / 4%)",
            } }, sx) }));
}
exports.Paywall = Paywall;
